export const MigrationStatus = {
  TEMPORARY_RESIDENT: '1',
  PERMANENT_RESIDENT: '2',
  TOURIST_OR_VISITOR: '3',
  WORK_PERMIT: '4',
  TRANSIT_PERSON: '5',
  CONSULAR_PERMIT_OR_SIMILAR: '6',
  NATIONALIZED_OR_NATURALIZED: '7',
  OTHER: '8'
} as const

export type MigrationStatus = (typeof MigrationStatus)[keyof typeof MigrationStatus]

export const MigrationStatusLabel = {
  [MigrationStatus.TEMPORARY_RESIDENT]: 'Residente temporal',
  [MigrationStatus.PERMANENT_RESIDENT]: 'Residente permanente',
  [MigrationStatus.TOURIST_OR_VISITOR]: 'Turista o visitante',
  [MigrationStatus.WORK_PERMIT]: 'Con permiso de trabajo',
  [MigrationStatus.TRANSIT_PERSON]: 'Persona en tránsito',
  [MigrationStatus.CONSULAR_PERMIT_OR_SIMILAR]: 'Permiso consular o similar',
  [MigrationStatus.NATIONALIZED_OR_NATURALIZED]: 'Nacionalizado / Naturalizado en Guatemala',
  [MigrationStatus.OTHER]: 'Otra'
} as const satisfies Record<MigrationStatus, string>
